import * as yup from "yup";
import i18n from "./i18n";

const withField = (params: any, msg: string) => {
  const name = params?.label || params?.path;
  return name ? `${name}: ${msg}` : msg;
};

yup.setLocale({
  mixed: {
    required: (params) =>
      withField(params, i18n.t("greco.form.errors.required")),
  },
  number: {
    min: (params) =>
      withField(
        params,
        i18n.t("greco.form.errors.number.min", { min: params.min })
      ),
    max: (params) =>
      withField(
        params,
        i18n.t("greco.form.errors.number.max", { max: params.max })
      ),
  },
});

export default yup;
